import { transform } from '../../../lib/transform';
import { IPublicationProductProperties } from './i-publication-product-properties';
import { TagManagerProductDto } from './tag-manager-product.dto';

export function buildPublicationProduct(
  properties: IPublicationProductProperties,
) {
  return transform(TagManagerProductDto, {
    category: properties.publicationType,
    id: properties.assetName,
    name: properties.assetName,
    dimension5: properties.assetType,
  });
}
